module.exports = __webpack_public_path__ + "media/images/flags/gr-8fb75d94a36c96b803b1ad27c495717b.svg";